import Link from "next/link";
import { ProductCard } from "./ProductCard";
import type { PublicCommunityProduct } from "@/lib/community/types";

interface CollectionCarouselProps {
  collection: {
    internal_id: string;
    name: string;
    description?: string | null;
  };
  products: PublicCommunityProduct[];
}

export function CollectionCarousel({
  collection,
  products,
}: CollectionCarouselProps) {
  if (products.length === 0) return null;

  return (
    <section className="mb-12">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div className="min-w-0">
          <h2 className="text-h3 text-ink">{collection.name}</h2>
          {collection.description && (
            <p className="mt-1 text-sm text-muted line-clamp-1">
              {collection.description}
            </p>
          )}
        </div>
        <Link
          href={`/community/search?collection=${collection.internal_id}`}
          className="shrink-0 inline-flex items-center min-h-[44px] rounded-md text-sm font-medium text-brand-green hover:text-brand-green focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600"
        >
          See all
        </Link>
      </div>
      <div className="flex gap-4 overflow-x-auto snap-x pb-2 no-scrollbar">
        {products.map((product) => (
          <div key={product.id} className="w-40 sm:w-44 shrink-0 snap-start">
            <ProductCard product={product} />
          </div>
        ))}
      </div>
    </section>
  );
}
